// extracted by mini-css-extract-plugin
module.exports = {"body":"BaseCardBody_body__yX8iL"};